import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";

const LoginModal = ({ closeModal }) => {
  const navigate = useNavigate();

  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = login(email, password);
    if (!success) {
      setError("Credenciales incorrectas");
    } else {
      closeModal();

      // Supongamos que tu user tiene un curso asignado
      const user = JSON.parse(localStorage.getItem('user'));

      const courseId = user?.courseId || "1"; // Por ejemplo el ID del curso asignado

      navigate(`/course-player/${courseId}`);
    }
  };

  return (
    <div className="modal-login">
      <div className="modal-overlay">
        <div className="modal-content-login">
          <button onClick={closeModal} className="close-modal">
            X
          </button>

          <h2>Iniciar Sesión</h2>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Correo"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña"
              required
            />
            <button type="submit" className="btn btn-primary btn-login py-2 px-5 ml-auto">Iniciar Sesión</button>
            {error && <p className="error">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
